
                    import wasm from "@shortex/perspective-viewer/dist/pkg/perspective_bg.wasm";
                    export default Promise.resolve(wasm);
                